// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__FQWFc","content":"LoadingAlert_content__2BMcW"};